import React from 'react';
import { useSelector } from 'react-redux';
import { CalendarCheckIcon, CalendarXIcon, CoinsIcon, LockIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { selectPageModelCategoryId, selectPageModelRegionId } from 'store/pageModel';
import { getDeadlineText } from 'utils';

import { BenefitItem, BenefitsContainer, iconColor, titleStyles } from './styled';
import { selectConfigurators, selectInstallationDeadline } from '../../selectors';
import { useLocation } from '@okapi/router-react';

export const CATEGORIES_EXTENDED_WARRANTY = [1063, 1140, 2038, 321];
export const desiredDatePaths = [
	'/uslugi/catalogue/ustanovka-metallicheskoy-dveri/',
	'/uslugi/catalogue/ustanovka-mezhkomnatnyh-dverey/',
	'/uslugi/catalogue/montazh-kuhon/',
	'/uslugi/catalogue/sborka-i-ustanovka-sistem-hraneniya/',
];

export const Benefits = () => {
	const deadlineDays = useSelector(selectInstallationDeadline) || 14;
	const deadlineText = `${deadlineDays}\u00A0${getDeadlineText(deadlineDays)}`;
	const [path] = useLocation();
	const region = useSelector(selectPageModelRegionId);
	const isDesiredDateCategory = desiredDatePaths.includes(path) && region === '34';

	const categoryId = useSelector(selectPageModelCategoryId);
	const isExtendedWarranty = CATEGORIES_EXTENDED_WARRANTY.includes(Number(categoryId));

	const configurators = useSelector(selectConfigurators);

	const configuartorIsAvailable = configurators.some(({ isAvailable }) => isAvailable === true);

	return (
		<BenefitsContainer>
			<BenefitItem key={`benefit-warranty`} data-qa={`benefit-warranty`}>
				<LockIcon type="duotone" size="xxl" className={iconColor} />
				<div>
					<Typography
						size="body_accent"
						variant="m"
						as="h4"
						className={titleStyles}
						overrideStyles={false}
					>
						Гарантия качества услуг
					</Typography>
					<Typography size="body_long" variant="s" as="p">
						Гарантия 1 год
						{isExtendedWarranty &&
							', для держателей Ключ-карты для дома\u00A0— 2\u00A0года'}
					</Typography>
				</div>
			</BenefitItem>
			<BenefitItem key={`benefit-price`} data-qa={`benefit-price`}>
				<CoinsIcon type="duotone" size="xxl" className={iconColor} />
				<div>
					<Typography
						size="body_accent"
						variant="m"
						as="h4"
						className={titleStyles}
						overrideStyles={false}
					>
						Фиксированные цены
					</Typography>
					<Typography size="body_long" variant="s" as="p">
						Цены зафиксированы и&nbsp;не&nbsp;меняются в&nbsp;процессе выполнения заказа
					</Typography>
				</div>
			</BenefitItem>
			<BenefitItem key={`benefit-deadline`} data-qa={`benefit-deadline`}>
				{configuartorIsAvailable ? (
					<>
						<CalendarCheckIcon type="duotone" size="xxl" className={iconColor} />
						<div>
							<Typography
								size="body_accent"
								variant="m"
								as="h4"
								className={titleStyles}
								overrideStyles={false}
							>
								{!isDesiredDateCategory
									? `Работы начнутся в течение ${deadlineText}`
									: 'Выбор даты начала работ'}
							</Typography>
							<Typography size="body_long" variant="s" as="p">
								{!isDesiredDateCategory
									? 'Мастер договорится с вами об удобных дате и времени'
									: 'Удобную для вас дату можно выбрать при оформлении заказа'}
							</Typography>
						</div>
					</>
				) : (
					<>
						<CalendarXIcon type="duotone" size="xxl" className={iconColor} />
						<div>
							<Typography
								size="body_accent"
								variant="m"
								as="h4"
								className={titleStyles}
								overrideStyles={false}
							>
								Выбор даты недоступен
							</Typography>
							<Typography size="body_long" variant="s" as="p">
								Опция появится, когда услуга станет активной
							</Typography>
						</div>
					</>
				)}
			</BenefitItem>
		</BenefitsContainer>
	);
};
